import type {ConnectionDeviceEdgeApiInterface} from '@app/shared/interfaces/edgeapi/connectionEgeDeviceApi.ts'
import type {ConnectionNativeEdgeApiInterface} from '@app/shared/interfaces/edgeapi/connectionEdgeNativeApi'
import type {ConnectionMQTTEdgeApiInterface} from '@app/shared/interfaces/edgeapi/connectionMQTTEdgeApi'

export type ConnectionEdgeApiInterface =
  | ConnectionDeviceEdgeApiInterface
  | ConnectionNativeEdgeApiInterface
  | ConnectionMQTTEdgeApiInterface

export enum ConnectionTypeEdgeApiEnum {
  CONNECTION_DEVICE = 'ConnectionDevice',
  CONNECTION_NATIVE = 'ConnectionNative',
  CONNECTION_MQTT = 'ConnectionMQTT',
}
